import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { PageLayout } from 'coreOld/components';
import { RequestDetails, RequestJobList } from 'support/components';

import { filtersConfig } from './configs';

const RequestJobListPage = () => {
  const { t } = useTranslation();

  const { id: requestId } = useParams();

  return (
    <PageLayout
      title={t('titleSupportRequestId', { id: requestId })}
      hasSubHeader={false}
      hasSearchBar={false}
    >
      <RequestJobList filtersConfig={filtersConfig} requestId={Number(requestId)} />

      <RequestDetails />
    </PageLayout>
  );
};

export default RequestJobListPage;
